import React from 'react';
import { fullStateName } from '../../../utils/utils';
import './StateWithholdingNonMandatory.scss';
import If from 'src/components/Shared/If/If';
import { useSelector } from 'react-redux';
import { getWithholdingStateLookup } from '../../../redux/modules/stateWithholding/selectors';

const StateWithholdingNonMandatory = ({
  state,
  multiState = false,
  mandatoryStates = false,
  isSalesforceRepMessage = false,
}) => {
  const statesList = useSelector(getWithholdingStateLookup);
  return (
    <div className="state-withholding-non-mandatory">
      <If test={!isSalesforceRepMessage}>
        <h1 className="state-withholding-non-mandatory-heading">
          {' '}
          State Income Tax Withholding Disclosure
        </h1>
      </If>
      <If test={isSalesforceRepMessage}>
        <span className="state-withholding-non-mandatory-leader">
          State Income Tax Withholding Disclosure
        </span>
      </If>

      <ul className="state-withholding-non-mandatory-list">
        {multiState && mandatoryStates && (
          <li className="state-income-tax-disclosure-item">
            Your IRAs are associated with the following default withholding
            states and state taxes will be withheld accordingly with the
            exception of those addresses which are in Connecticut, Michigan and
            Minnesota
            {state.map((stateName) => (
              <div className="multi-mandatory-state-withholding">
                {statesList?.[stateName ?? '']?.mandatory && (
                  <ul>
                    <li>
                      <span>
                        {fullStateName(stateName)} (
                        {statesList?.[stateName ?? '']?.percent}%
                        {stateName === 'DC' && (
                          <span>
                            {' '}
                            of the distribution when taking a total distribution
                            from an account)
                          </span>
                        )}
                        {(stateName === 'AR' ||
                          stateName === 'KS' ||
                          stateName === 'NC') && (
                          <span>
                            {' '}
                            of distribution when distributions are greater than
                            $200)
                          </span>
                        )}
                        {(stateName === 'CA' || stateName === 'VT') && (
                          <span> of federal withholding)</span>
                        )}
                        {stateName !== 'DC' &&
                          stateName !== 'AR' &&
                          stateName !== 'KS' &&
                          stateName !== 'NC' &&
                          stateName !== 'CA' &&
                          stateName !== 'VT' && <span> of distribution)</span>}
                      </span>
                    </li>
                  </ul>
                )}
              </div>
            ))}
          </li>
        )}
        {!multiState && !mandatoryStates && (
          <li className="state-withholding-non-mandatory-item">
            {' '}
            Your IRA is associated with an address in{' '}
            <span className="state-withholding-non-mandatory-leader">
              {state && fullStateName(state)}
            </span>
            {state === 'MN' && (
              <span>
                , where state income tax withholding is{' '}
                <span className="state-income-tax-disclosure-leader">
                  6.25% of your redemption amount.
                </span>
              </span>
            )}
            {state !== 'MN' && (
              <span>
                , which is a state that does not default to state income tax
                withholding.
              </span>
            )}
          </li>
        )}
        {multiState && !mandatoryStates && (
          <li className="state-withholding-non-mandatory-item">
            Your IRA is associated with an address where state income tax
            withholding is{' '}
            <span className="state-withholding-non-mandatory--leader">
              not mandatory.
            </span>
          </li>
        )}
        {state !== 'MN' && (
          <li className="state-withholding-non-mandatory-item">
            State income tax will not be withheld from your distribution
          </li>
        )}
        {state === 'MN' && (
          <>
            <li className="state-income-tax-disclosure-item">
              You can elect out of the default state withholding by contacting
              us and processing the transaction by phone. Withholding will not
              occur on direct rollovers. You will be required to submit Form
              W-4MNP to elect out of withholding for distributions other than a
              a conversion from a Traditional IRA to Roth IRA.
            </li>{' '}
            <li className="state-income-tax-disclosure-item">
              If you continue your transaction online we will treat that as an
              election to withhold Minnesota income tax on any type of
              distribution except a rollover.
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default StateWithholdingNonMandatory;
